// extracted by mini-css-extract-plugin
export default {"default":"close-button_default__kUo-2","startPage":"close-button_startPage__CbwyY"};